import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SidebarState {
  mini: boolean;
  toggleMini: () => void;
}

/** Collapsed ("mini") desktop sidebar, remembered across visits. */
export const useSidebarStore = create<SidebarState>()(
  persist((set) => ({ mini: false, toggleMini: () => set((s) => ({ mini: !s.mini })) }), {
    name: 'fair-doctor-sidebar',
    storage: createJSONStorage(() => localStorage),
  }),
);
